import { ChargingKeyActionResult, ChargingKeyModel } from 'api/model';
import toast from 'react-hot-toast';

/** Det personalen känner igen: tryckta numret, annars UID. */
export const chargingKeyLabel = (key: Pick<ChargingKeyModel, 'visualNumber' | 'uid'>) =>
  key.visualNumber || key.uid;

/**
 * Tilldelning sparas i ZäkraGo även när förarnamnet inte når Fortum — då kommer en varning
 * tillbaka som ska synas, annars ser det ut som att allt gick igenom.
 */
export const toastChargingKeyResult = (
  result: ChargingKeyActionResult,
  successMessage: string
) => {
  if (result.warning) {
    toast(result.warning, { icon: '⚠️', duration: 8000 });
  } else {
    toast.success(successMessage);
  }
};
